import { ManagerData } from 'api/types/data';

import { FileEntity } from '../fileEntity';
import { OperationStatusType } from '../operation/operationStatusType';

import { OrderConfirmationDocumentEntity } from './orderConfirmationDocumentEntity';
import { OrderDetailsEntity } from './orderDetailsEntity';
import { OrderExecutionTermsEntity } from './orderExecutionTermsEntity';
import { OrderFinancialInstrumentEntity } from './orderFinancialInstrumentEntity';
import { OrderOperationType } from './orderOperationType';
import { OrderStatusHistoryEntity } from './orderStatusHistoryEntity';
import { OrderStatusType } from './orderStatusType';
import { OrderTransactionVolumeEntity } from './orderTransactionVolumeEntity';
import { OrderType } from './orderType';

export enum OrderMarketType {
  Secondary = 'Secondary',
  Primary = 'Primary',
}

export enum OrderTransactionVenueType {
  /** Организованный рынок */
  Organized = 'Organized',
  /** Неорганизованный рынок */
  Unorganized = 'Unorganized',
}

export enum OrderSettlementConditionType {
  /** Предпоставка бумаг */
  PreDeliveryOfSecurities = 'PreDeliveryOfSecurities',
  /** Предоплата денежных средств */
  PrePaymentOfFunds = 'PrePaymentOfFunds',
  /** Нет */
  None = 'None',
}

export interface OrderEntity {
  id: string;

  createdAt: Date;

  signedAt?: Date;

  /** Тип операции */
  operationType: OrderOperationType;

  /** Тип поручения */
  orderType: OrderType;

  /** Статус */
  status: OrderStatusType;

  /** Номер поручения */
  number?: number;

  /** Форма поручения */
  fmNumber?: string;

  /** Место заключения сделки */
  transactionVenue?: OrderTransactionVenueType;

  /** Наличие рекомендации брокера */
  hasBrokerRecommendation?: boolean | null;

  /** Тип рынка */
  marketType?: OrderMarketType;

  /** Условие расчетов */
  settlementCondition?: OrderSettlementConditionType;

  manager?: ManagerData;

  /** [Срок исполнения] Начало действия поручения */
  startDate?: Date;

  /** [Срок исполнения] Окончание действия поручения */
  endDate?: Date;

  /** [Срок исполнения] Срок исполнения (рабочие дни) */
  executionPeriodInBusinessDays?: number;

  /** [Срок исполнения] Дата закрытия поручения */
  closedDate?: Date;

  /** Условия исполнения */
  executionTerms: OrderExecutionTermsEntity;

  /** Финансовый инструмент */
  financialInstrument: OrderFinancialInstrumentEntity;

  /** Объем сделки */
  transactionVolume?: OrderTransactionVolumeEntity;

  /** Объем перевода */
  transferVolume?: OrderTransactionVolumeEntity;

  /** Реквизиты отправителя */
  senderDetails?: OrderDetailsEntity;

  /** Реквизиты получателя */
  recipientDetails?: OrderDetailsEntity;

  /** Дополнительные параметры */
  additionalParameters?: {
    /** Дата сделки */
    transactionDate?: Date;
    /** Дата расчетов */
    settlementDate?: Date;
  };

  /** Подтверждающий документ */
  confirmationDocument?: OrderConfirmationDocumentEntity;

  /** Комментарий */
  comment?: string;

  /** Дополнительные документы */
  adminDocuments?: FileEntity[];

  owner: {
    id: string;
    type: 'person' | 'legal';
    fullName?: string;
    accountNumber?: string;
  };

  versionNumber?: number;

  statusesHistory?: OrderStatusHistoryEntity[];

  /** Сделки */
  requestedQuantity?: number;
  executedQuantity?: number;
  operations?: {
    id: string;
    status: OperationStatusType;
    number: string;
    isin: string;
    executedAt: Date;
    quantity: number;
    netUnitPrice: string;
  }[];
}
